import { styled } from '@styledComponents';
import { Flex } from '@components/Flex';
import { Button } from '@components/Button';
import { themeColor, themeSpace, themeMediaQuery } from '@utils/styledTheme.util';
import { JoykitIcon } from '@components/JoykitIcon';
import { Text } from '@components/typography';

export const StyledBannerContainer = styled(Flex)<{ showBanner: boolean }>`
  opacity: ${({ showBanner }) => (showBanner ? 0.9 : 0)};
  background: ${themeColor('humana1Light')} !important;
  padding: ${themeSpace(4)} ${themeSpace(7)};
  border-radius: 4px 4px 0px 0px;
  width: 857px;
  margin: auto;
  position: relative;
  ${themeMediaQuery('below_sm')} {
    display: block;
    width: 100%;
    border-radius: 0px;
    opacity: ${({ showBanner }) => (showBanner ? 0.8 : 0)};
    padding: ${themeSpace(4)} ${themeSpace(5)};
  }
  ${themeMediaQuery('sm')} {
    width: 794px;
  }
  ${themeMediaQuery('md')} {
    width: 857px;
  }
`;

export const StyledCloseButton = styled(Button)`
  top: 0;
  right: 0;
  position: absolute;
  background: transparent;
  height: 45px;
  padding: 0px ${themeSpace(5)};
  &:hover {
    background: transparent;
  }
`;

export const StyledCloseIcon = styled(JoykitIcon)`
  width: 12.5px;
  height: 12.5px;
`;

export const ContentWrapper = styled.div`
  ${themeMediaQuery('below_sm')} {
    width: 100%;
    margin-bottom: ${themeSpace(6)};
    margin-top: ${themeSpace(7)};
  }
`;

export const StyledText = styled(Text)`
  width: 524px;
  font-size: 13px;
  line-height: 22px;
  .privacy-link {
    font-weight: 700;
    color: ${themeColor('neutra6')};
  }
  ${themeMediaQuery('below_sm')} {
    width: 339px;
    align-items: center;
    text-align: center;
  }
`;

export const ActionsWrapper = styled.div`
  width: 400px;
  margin-top: ${themeSpace(4)};
  ${themeMediaQuery('below_sm')} {
    width: 100%;
    text-align: center;
  }
`;

export const StyledLink = styled(Button)`
  font-size: 14px;
  line-height: 26px;
  font-weight: 700;
  height: 34px;
  padding: ${themeSpace(1)} ${themeSpace(4)};
  letter-spacing: 0.01em;
  margin: 0px 0px ${themeSpace(4)} ${themeSpace(5)};
  color: ${themeColor('neutra6')};
  border-color: ${themeColor('neutra6')};
  border-radius: 4px;
  &:hover {
    color: ${themeColor('neutra6')};
    border-color: ${themeColor('neutra6')};
    background: transperant;
  }
`;

export const StyledLinkDecline = styled(StyledLink)`
  border-width: 0px;
  margin: 0px ${themeSpace(5)} ${themeSpace(4)} ${themeSpace(1)};
`;
